import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const MUTATING_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
const CSRF_HEADER = 'X-CSRF-Token';

/**
 * CSRF interceptor — replaces the legacy `$http.defaults.headers` pattern from auth.service.js.
 *
 * The token is set by AuthenticationService after successful login or CSRF refresh.
 * It is attached to mutating HTTP methods automatically.
 */
@Injectable({ providedIn: 'root' })
export class CsrfInterceptor implements HttpInterceptor {
  private token: string | null = null;

  setToken(token: string | null): void {
    this.token = token;
  }

  clearToken(): void {
    this.token = null;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.token && MUTATING_METHODS.has(req.method.toUpperCase())) {
      return next.handle(req.clone({ setHeaders: { [CSRF_HEADER]: this.token } }));
    }
    return next.handle(req);
  }
}
